import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

export const StoreDetails = ({ data = {} }) => {
  const { name, address, city, state, zipCode, id } = data;

  const details = [
    { label: 'Store Name', data: name },
    { label: 'Store Id', data: id, link: true, route: 'stores', id },
    { label: 'Address', data: address },
    { label: 'City', data: city },
    { label: 'State', data: state },
    { label: 'Zip Code', data: zipCode },
  ];

  return <DataCard title="Store Details" cardData={details} />;
};

StoreDetails.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }),
};
